import React from 'react'
import MonthlyCalendar from '../components/MonthlyCalendar'
import Nav from '../components/NavCal'

export default function Calendar() {
  return (
    <div>
        <Nav />
        <MonthlyCalendar />
    </div>
  )
}
